import {BaseResource} from './Resource';

/**
 * Funding Resource
 */
class Funding extends BaseResource
{
    constructor() {
        super()
        this.handle = 'funding'
        this.resourceSegments = ['funding']
    }

    getHandle() {
        return this.handle
    }

    all(params = {}, config = {}) {
        return this._doGet([], params, config)
    }

    send(instance_id, finance_house, funding_type, funded_value, plan_starts_at, funding_expires_at) {
        return this._doPost([], {
            instance_id, finance_house, funding_type, funded_value, plan_starts_at, funding_expires_at
        })
    }

    settle(instance_id, funding_settled_at) {
        return this._doPut(['settle', instance_id], { funding_settled_at })
    }

    remove(instance_id) {
        return this._doDelete([instance_id])
    }

    options() {
        return this._doGet(['options']);
    }
}

export let FundingResource = new Funding();

export const FundingStatuses = {
    PENDING: 'pending', // With IOData
    VALIDATING: 'validating', // With IOData
    PROCESSING: 'processing', // With APAK
    FAILED: 'failed',

    QUERIED: 'queried', // IOData Validation returned a minor issue but the unit was sent for funding
    WITHHELD: 'withheld', // The unit failed at APAK
    LIVE: 'live', // The unit was funded
    SETTLED: 'settled', // The unit was funded
    ERROR: 'error', // Something went Pete Tong
    PENDING_REMOVAL: 'pending_removal' // Waiting to confirm that it has been removed via APAK
}

export const FundingValidationStatuses = {
    RED: 'red',
    ORANGE: 'amber',
    GREEN: 'green',
    GREY: 'grey',
}